// extracted by mini-css-extract-plugin
module.exports = {"content":"AuthorizeToLogin_content__1Za8q","sendOtp":"AuthorizeToLogin_sendOtp__Hb7TB"};